<template>
  <div
    class="flex flex-row max-w-[170px] space-x-4 bg-[#e4e6ec] dark:border-[#292929] dark:bg-[#171717] items-center rounded-lg px-4 py-2"
  >
    <svg
      class="w-8 h-8 fill-current duration-200 text-[#676f7d] dark:text-white transition-colors"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
      ></path>
    </svg>

    <Switch
      v-model="enabled"
      :class="[
        enabled ? 'bg-white' : 'bg-[#303030]',
        'relative inline-flex flex-shrink-0 h-6 w-12 border-2 border-transparent rounded-lg cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none',
      ]"
    >
      <span class="sr-only">Theme Setting</span>

      <span
        aria-hidden="true"
        :class="[
          enabled ? 'translate-x-6' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 rounded-lg bg-gold dark:bg-fire shadow transform ring-0 transition ease-in-out duration-200',
        ]"
      />
    </Switch>
    <svg
      class="w-8 h-8 fill-current text-gold dark:text-gold"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
        clip-rule="evenodd"
      ></path>
    </svg>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { Switch } from "@headlessui/vue";

export default {
  components: {
    Switch,
  },
  setup() {
    const enabled = ref(false);
    const theme = ref("");

    onMounted(() => {
      enabled.value = localStorage.getItem("theme") === "light";
    });

    watch(enabled, (value) => {
      if (value) {
        localStorage.setItem("theme", "light");
        theme.value = "light";
        document.documentElement.classList.remove("dark");
      } else {
        localStorage.setItem("theme", "dark");
        theme.value = "dark";
        document.documentElement.classList.add("dark");
      }

      /*axios.post('/settings', {
                'theme': theme.value
            })*/
    });

    return {
      enabled,
    };
  },
};
</script>
